import createDOMPurify from 'dompurify'
// import { JSDOM } from 'jsdom'

export default dirty => {
  const isBrowser = typeof window !== 'undefined'
  const DOMPurify = isBrowser ? createDOMPurify(window) : null

  if (!DOMPurify) return dirty

  // Allow iframe tags for embedded content (YouTube, etc.)
  return DOMPurify.sanitize(dirty, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'frameborder',
      'src',
      'width',
      'height',
      'title',
    ],
  })
  // let sanitizer = DOMPurify
  // if (window) {
  //   sanitizer = DOMPurify
  // } else {
  //   sanitizer = DOMPurify(new JSDOM('').window)
  // }

  // return sanitizer.sanitize(html)

  // return html
}
